// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5bdb63ec] .indent-menu svg {\n  margin-left: 25px !important;\n}\n[data-v-5bdb63ec] .sidebar-minimized .indent-menu-text svg {\n  margin-left: 15px !important;\n}\n[data-v-5bdb63ec] .sidebar .indent-menu-text .nav-link svg.nav-icon {\n  margin-left: 25px;\n}\n[data-v-5bdb63ec] .side-link-active .nav-dropdown-items {\n  max-height: unset;\n}\n\n", ""]);
// Exports
module.exports = exports;
